import React from 'react';
import { componentService } from 'js/services/component.service';

export const DynamicContactPreferences = React.lazy(() => import(/* webpackChunkName: "dynamic-contact-preferences" */ './DynamicContactPreferences'));

componentService.registerPageComponents({ 'dynamic-contact-preferences': DynamicContactPreferences });
